import { CardImageTextProps } from "modules/common/components/CardDetailsDialog/CardImageText";
import { getCardPresentationAdapter } from "modules/common/gameRegistry";

export const CardEssentialInfo = ({ card }: CardImageTextProps) => {
  const adapter = getCardPresentationAdapter(card.game);
  return adapter.renderEssentialInfo(card);
};
